import { isPlatformBrowser, NgClass } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink, RouterOutlet, RouterLinkActive } from '@angular/router';
import { AlertComponent } from '../../../../../shared/components/alert/alert/alert';
import { LoginService } from '../../../../auth/login.service';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';
import { SocketService } from '../../../../../core/services/socket.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { OrderNotificationComponent } from '../../order-notification/order-notification';

type NavItems = { label: string; icon: string; path: string };

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    NgClass,
    AlertComponent,
    TranslatePipe,
    OrderNotificationComponent,
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar implements OnInit, OnDestroy {
  navItems: NavItems[] = [
    // { label: 'Profile', icon: 'fa-user', path: 'profile' },
    { label: 'Dashboard', icon: 'fa-chart-line', path: 'dashboard' },
    { label: 'Ticket', icon: 'fa-ticket', path: 'ticket' },
    { label: 'Confirm Order', icon: 'fa-check-double', path: 'confirmed-order' },
    { label: 'Lottery', icon: 'fa-clover', path: 'lottery' },
    { label: 'Card', icon: 'fa-credit-card', path: 'card' },
    { label: 'Account', icon: 'fa-wallet', path: 'account' },
    { label: 'Order', icon: 'fa-cart-shopping', path: 'order' },
    { label: 'Result', icon: 'fa-check-circle', path: 'result' },
    { label: 'Settings', icon: 'fa-gear', path: 'settings' },
  ];

  isCollapsed: boolean = false;
  private isBrowser: boolean;
  ready: boolean = false;
  showLogoutConfirm: boolean = false;

  // Store reference so ngOnDestroy can remove the exact same callback
  private readonly newOrderCallback = (order: any) => {
    this.notificationService.showNewOrderNotification(order);
  };

  constructor(
    private loginService: LoginService,
    public router: Router,
    private socketService: SocketService,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const localIsCollapsed = localStorage.getItem('isCollapsed');
      if (localIsCollapsed !== null) {
        this.isCollapsed = JSON.parse(localIsCollapsed);
      }

      this.socketService.listenNewOrderGlobal();
      this.socketService.onNewOrderGlobal(this.newOrderCallback);
    }
    this.ready = true;
  }

  toggleSideBar() {
    this.isCollapsed = !this.isCollapsed;

    if (this.isBrowser) {
      localStorage.setItem('isCollapsed', JSON.stringify(this.isCollapsed));
    }
  }

  signOut() {
    this.showLogoutConfirm = true;
  }

  confirmSignOut() {
    this.loginService.logout();
    this.router.navigate(['/admin']);
    this.showLogoutConfirm = false;
  }

  cancelSignOut() {
    this.showLogoutConfirm = false;
  }

  ngOnDestroy(): void {
    this.socketService.removeNewOrderGlobalObserver(this.newOrderCallback);
  }
}
